<template>
  <div class="protocol">
    Last revised on August 4, 2026
    <br /><br />

    <div class="bt" style="text-align: center">
      {{ appName }}'s Child Safety Standards
    </div>

    <div class="bt subtitle">Child Safety Commitment</div>

      <br/><br/>
    {{ appName }} is committed to protecting children and maintaining a safe environment for all users.
      <br/><br/>

    {{ appName }} strictly prohibits any form of Child Sexual Abuse and Exploitation (CSAE), including but not limited to:
      <br/><br/>

      - Child Sexual Abuse Material (CSAM) <br/>
      - Sexual exploitation of children <br/>
      - Sexual grooming of minors <br/>
      - Sexual harassment or inappropriate interactions involving minors <br/>
      - Any content or behavior that harms or exploits children <br/>
      - Creating, sharing, distributing, or promoting child sexual abuse material <br/>

      <br/>
      Any user found engaging in child sexual abuse or exploitation will have their account restricted, suspended, or permanently banned.
      <br/><br/>

      <div class="bt subtitle">
      Reporting Child Safety Concerns
      <br/><br/>
      </div>

    {{ appName }} provides users with reporting channels to report suspected child safety violations.
      <br /><br />

      Users can report: <br/><br/>

      - Child sexual abuse content <br/>
      - Inappropriate interactions involving minors <br/>
      - Suspected CSAE activities <br/>
      - Any other content that may threaten child safety <br/><br/>

      Users can submit reports through: <br/>
      Email: tomo7ichat@gmail.com
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.table-container {
  width: 100%; /* 或任何具体宽度 */
  overflow-x: auto;
}
table {
  border-collapse: collapse; /* 合并边框 */
  max-width: 100%;
  width: 100%;
  margin: 0.2267rem 0; /* 外边距 */
  font-family: Arial, sans-serif; /* 字体 */
}
td {
  padding: 0.2267rem; /* 内边距 */
  border: 1px solid #ddd; /* 边框 */
  word-wrap: break-word; /* 允许长单词换行 */
  white-space: normal; /* 允许内容换行 */
}

.protocol {
  /* overflow: hidden; */
  width: 100%;
  font-size: 0.9rem;
  margin-bottom: 0.4667rem;
  color: #666;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  box-sizing: border-box;
}
.bt {
  font-size: 1.3rem;
  margin: 0.2rem 0px;
  color: #000;
}
.subtitle {
  font-size: 1.1rem;
  color: #333;
}
</style>
